module.exports = __webpack_public_path__ + "static/media/a-5.236d97bd.jpg";